function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#heart_svg__clip0)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "heart_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.313 17.437L16.177 28.574a.25.25 0 01-.354 0L4.687 17.437A8 8 0 0115.82 5.948c.1.094.26.094.36 0a8 8 0 0111.134 11.488z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.687 17.436l-.884.884.884-.884zM15.82 5.95l.856-.911-.856.91zm.36 0l-.856-.911.856.91zM4.687 17.437l-.884.883.884-.883zm11.49 11.137l-.884-.884.884.884zm11.136-11.137l.884.884-.884-.884zm-10.252 12.02l11.136-11.136-1.767-1.768L15.293 27.69l1.768 1.768zM3.803 18.322l11.136 11.137 1.768-1.768L5.571 16.553l-1.768 1.768zm0 0l1.768-1.768-1.768 1.767zm0-13.082a9.25 9.25 0 000 13.081l1.767-1.767a6.75 6.75 0 010-9.546L3.803 5.239zm12.873-.201a9.25 9.25 0 00-12.873.201L5.57 7.007a6.75 6.75 0 019.394-.148l1.712-1.821zm.36 1.821a6.75 6.75 0 019.394.148l1.767-1.768a9.25 9.25 0 00-12.873-.201l1.712 1.821zm9.394.148a6.75 6.75 0 010 9.546l1.767 1.767a9.25 9.25 0 000-13.08L26.43 7.006zm0 9.546l1.767 1.767-1.767-1.767zM14.964 6.859c.582.547 1.49.547 2.072 0l-1.712-1.821a.986.986 0 011.352 0l-1.712 1.821zM5.57 18.321a1.25 1.25 0 000-1.768L3.803 18.32a1.25 1.25 0 010-1.767l1.768 1.768zm0-1.768a1.25 1.25 0 010 1.768l-1.768-1.768a1.25 1.25 0 000 1.768l1.768-1.768zm9.722 11.137a1 1 0 011.414 0l-1.768 1.768a1.5 1.5 0 002.122 0l-1.768-1.768zm12.904-11.137a1.25 1.25 0 010 1.767l-1.767-1.767a1.25 1.25 0 000 1.768l1.767-1.768zm-1.767 1.768a1.25 1.25 0 010-1.768l1.767 1.768a1.25 1.25 0 000-1.768l-1.767 1.768z",
  fill: "currentColor",
  mask: "url(#heart_svg__a)"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "heart_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .064)",
  d: "M0 0h32v32H0z"
})));

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/heart.fd40f5fe.svg";
export { SvgHeart as ReactComponent };